export interface FeedingPeriod {
  id: string;
  feedingNo: number;
  description: string;
  displayColor: string;
  numberOfGroups: number;
  numberOfPremixes: number;
  numberOfRations: number;
  hasPremixesInRations: boolean;
  timeMonday: string;
  timeTuesday: string;
  timeWednesday: string;
  timeThursday: string;
  timeFriday: string;
  timeSaturday: string;
  timeSunday: string;
  notInUse: boolean;
  feedings?: Feeding[];
  baseRationGroups: FeedingBaseRationGroup[];
}

export interface FeedingPeriodWithFeedings extends FeedingPeriod {
  feedings: Feeding[];
}

export type IngredientDetails = {
  actualWeight: number;
  dryWeight: number;
  ingredientDescription: string;
  ingredientId: string;
  ingredientTypeCode: number;
  price: number;
};

export type Feeding = {
  id: string;
  feedingPeriodId: string;
  feedingNo: number;
  groupId: string;
  rationId: string;
  daysOnRation: number;
  feedingFactor: number;
  locked: boolean;
  loadWeight: number;
  loadWeightDry: number;
  lockedWeight: number;
  lockedPerc: number;
  baseRationId?: string;
  rationStartDate?: string;
  ingredients?: IngredientDetails[];
  feedingTime?: string;
  feedingTimeNextDay?: boolean;
};

export interface PreviewFeedingCreation {
  feedingId: string;
  id: string;
  draggableId: string;
  reqPerc: string;
  loadWeight: number;
  loadWeightDry: number;
  daysOnRation: number;
  numberOfDays: number;
  locked: boolean;
  feedingTime?: string;
  feedingTimeNextDay?: boolean;
}

export enum OptimizedColor {
  optimized,
  semiOptimized,
  notOptimized,
}

export interface FeedingOptimizationInfo {
  baseIndex?: number;
  itemIndex?: number;
  feedingId: string;
  optimized: boolean;
  optimizedColor: OptimizedColor;
  groupId: string;
}

export interface FeedingBaseRationGroup {
  baseRationId: string;
  feeding: FeedingOptimizationInfo;
  feedingsPlus: FeedingOptimizationInfo[];
  groupNumber: number;
  feedingNo: number;
}
